import type { LabelInputData } from './useLabelInputData.types';

export const INITIAL_STATE: LabelInputData['localState'] = {
  isCreating: false,
  searchValue: '',
  isCreateModalOpened: false,
  isGroupSelectOpened: false
};
